import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductAdvantageComponent} from './product-advantage/product-advantage.component';
import {CustomerStatementComponent} from './customer-statement/customer-statement.component';
import {TopBannerComponent} from './top-banner/top-banner.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import { HowItWorksFiguresComponent } from './how-it-works-figures/how-it-works-figures.component';
import { WhyBalikbayadFiguresComponent } from './why-balikbayad-figures/why-balikbayad-figures.component';
import { RequirementsFiguresComponent } from './requirements-figures/requirements-figures.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
  ],
  declarations: [
    ProductAdvantageComponent,
    CustomerStatementComponent,
    TopBannerComponent,
    HowItWorksFiguresComponent,
    WhyBalikbayadFiguresComponent,
    RequirementsFiguresComponent,
  ],
  exports: [
    ProductAdvantageComponent,
    CustomerStatementComponent,
    TopBannerComponent,
    HowItWorksFiguresComponent,
    WhyBalikbayadFiguresComponent,
    RequirementsFiguresComponent,
  ],
})
export class BannerModule {
}
